import Button from '@repo/ui/button'
import { UserCanceledIcon } from '@repo/ui/icons'
import Modal, { MODAL_BODY_CLASSNAME } from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { cancelEnrollment } from '../../../api/enrollments/cancel-enrollment'
import { useModalManager } from '../../../lib/hooks/use-modal-manager'
import { PaymentStatusEnum } from '../../../lib/types/enums/enrollment/payment-status.enum'
import { modalButtonConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { queryClient } from '../../../main'
import { CancelEnrollmentNotificationModal } from './cancel-enrollment-notification-modal'
import { CancelEnrollmentForm } from './enrollment-form/cancel-enrollment-form'

type Props = {
  id: number
  paymentStatus: PaymentStatusEnum
  isConfirmed: boolean
  onSuccess?: () => void
}

const CancelEnrollment = ({ id, paymentStatus, isConfirmed, onSuccess }: Props) => {
  const { modalState, toggleModal, closeModel } = useModalManager<
    'cancel-enrollment' | 'notification'
  >(['cancel-enrollment', 'notification'])
  const { mutateAsync: cancelEnrollmentMutation } = useMutation({
    mutationFn: cancelEnrollment,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('Inscription annulée')
      closeModel('cancel-enrollment')
      toggleModal('notification')
    }
  })

  const handleEmailSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['enrollments'] })
    if (onSuccess) onSuccess()
  }
  return (
    <div>
      <Button
        variant={'destructive'}
        icon={UserCanceledIcon}
        className="text-nowrap"
        label="Annuler l'inscription"
        onClick={() => toggleModal('cancel-enrollment')}
      />

      {/* cancel enrollment modal */}
      <Modal
        hideActions
        icon={UserCanceledIcon}
        isOpen={modalState['cancel-enrollment']}
        onCancel={() => toggleModal('cancel-enrollment')}
        title={"Annuler le bulletin d'inscription"}
      >
        <CancelEnrollmentForm
          className={MODAL_BODY_CLASSNAME}
          paymentStatus={paymentStatus}
          isConfirmed={isConfirmed}
          buttonsConfig={modalButtonConfig({
            onCancel: () => closeModel('cancel-enrollment'),
            onConfirm: async (data) => cancelEnrollmentMutation({ id, ...data })
          })}
        />
      </Modal>
      <CancelEnrollmentNotificationModal
        enrollmentId={id}
        isConfirmed={isConfirmed}
        isOpen={modalState.notification}
        closeModal={handleEmailSuccess}
      />
    </div>
  )
}

export default CancelEnrollment
